export default __webpack_public_path__ + "static/media/cp_geo_gi.03178824.svg";